export var version = '11.12.0';
// Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/version.js
// module id = mXIq
// module chunks = 3